import { EventEmitter } from '@angular/core';
var ButtonComponent = (function () {
    function ButtonComponent() {
        this.disabledStyle = 'primary';
        this.size = 'standard';
        this.onClick = new EventEmitter();
    }
    ButtonComponent.prototype.buttonClicked = function () {
        this.onClick.emit();
    };
    return ButtonComponent;
}());
export { ButtonComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/button/button.component.ts.pre-build-optimizer.js